import React from "react";
import { FieldRendererProps } from "../types";
import {
  FileInput, FileUploadContainer, UploadIcon, UploadText,
  FilePreviewContainer, FilePreview, FileIcon, FileInfo, FileName,
  FileSize, FileActions, FileActionButton, ErrorMessage,
} from "../styles";
import { TipoFormulario } from "../../../services/constantes";
import { FaUpload, FaDownload, FaFile, FaTrash } from "react-icons/fa";

export const FileFieldRenderer: React.FC<FieldRendererProps> = ({
  campo, modo, getFieldValue, errors,
  filePreview, dragActive,
  handleFileChange, handleFileRemove, handleDrag, handleDrop, handleDownloadFile,
}) => (
  <>
    {modo !== TipoFormulario.tpVisualizacao && (
      <>
        <FileInput
          id={`file-input-${campo.nome}`}
          type="file"
          onChange={(e) => {
            const fileInput = e.target as HTMLInputElement;
            const file = fileInput.files?.[0];
            if (file) {
              handleFileChange?.(campo.nome, file);
              fileInput.value = '';
            }
          }}
        />
        <FileUploadContainer
          className={dragActive?.[campo.nome] ? 'active' : ''}
          onClick={() => document.getElementById(`file-input-${campo.nome}`)?.click()}
          onDragEnter={(e) => handleDrag?.(e, campo.nome, true)}
          onDragLeave={(e) => handleDrag?.(e, campo.nome, false)}
          onDragOver={(e) => e.preventDefault()}
          onDrop={(e) => handleDrop?.(e, campo.nome, 'file')}
        >
          <UploadIcon><FaUpload /></UploadIcon>
          <UploadText>
            {dragActive?.[campo.nome]
              ? 'Solte o arquivo aqui'
              : 'Arraste e solte um arquivo ou clique para selecionar'}
          </UploadText>
        </FileUploadContainer>
      </>
    )}
    <FilePreviewContainer>
      {filePreview?.[campo.nome] ? (
        <FilePreview empty={false}>
          <FileIcon><FaFile /></FileIcon>
          <FileInfo>
            <FileName>{filePreview[campo.nome].name}</FileName>
            <FileSize>{filePreview[campo.nome].size}</FileSize>
          </FileInfo>
          <FileActions>
            <FileActionButton
              className="download"
              onClick={(e: any) => {
                e.preventDefault();
                handleDownloadFile?.(getFieldValue(campo.nome), filePreview[campo.nome].name);
              }}
              title="Baixar arquivo"
            >
              <FaDownload />
            </FileActionButton>
            {modo !== TipoFormulario.tpVisualizacao && (
              <FileActionButton
                className="remove"
                onClick={() => handleFileRemove?.(campo.nome)}
                title="Remover arquivo"
              >
                <FaTrash />
              </FileActionButton>
            )}
          </FileActions>
        </FilePreview>
      ) : (
        <FilePreview empty={true} />
      )}
    </FilePreviewContainer>
    {errors[campo.nome] && <ErrorMessage>{errors[campo.nome]}</ErrorMessage>}
  </>
);
